{
  "nav": {
    "layers": "Capas",
    "discover": "Descubrir",
    "random": "Artículo aleatorio",
    "configuration": "Configuración",
    "settings": "Configuración",
    "pro": "Versión PRO",
    "collections": "Colecciones",
    "play": "Jugar",
    "help": "Ayuda",
    "logout": "Cerrar sesión",
    "community": "Foro comunitario",
    "account": "Gestionar cuenta"
  },
  "auth": {
    "signIn": "Iniciar sesión",
    "signUp": "Registrarse",
    "signingIn": "Iniciando sesión...",
    "creatingAccount": "Creando cuenta...",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "username": "Usuario",
    "or": "o",
    "noAccount": "¿No tienes una cuenta?",
    "hasAccount": "¿Ya tienes una cuenta?",
    "loginFailed": "Error al iniciar sesión. Por favor, verifica tus credenciales.",
    "signupFailed": "Error al registrarse. Por favor, inténtalo de nuevo."
  },
  "map": {
    "loading": "Cargando mapa...",
    "ruler": "Gobernante",
    "culture": "Cultura",
    "religion": "Religión",
    "religionGeneral": "Religión general",
    "capital": "Capital",
    "population": "Población"
  },
  "layers": {
    "title": "Capas",
    "general": "GENERAL",
    "advanced": "Avanzado",
    "area": "Área",
    "label": "Etiqueta",
    "markers": "Marcadores",
    "epics": "Epopeyas",
    "migration": "Migración",
    "basemap": "Mapa base",
    "showProvinces": "Mostrar provincias",
    "opacityByPopulation": "Opacidad según población",
    "clusterMarkers": "Agrupar marcadores",
    "markerLimit": "Límite de marcadores",
    "uncheckAll": "Desmarcar todos",
    "checkAll": "Marcar todos",
    "suggestions": "Sugerencias basadas en tu equipo...",
    "markerTypes": {
      "artifact": "Artefacto",
      "battle": "Batalla",
      "siege": "Asedio",
      "capital": "Capital",
      "city": "Ciudad",
      "castle": "Castillo",
      "landmark": "Lugar emblemático",
      "military": "Militar",
      "politician": "Político",
      "explorer": "Explorador",
      "scientist": "Científico",
      "artist": "Artista",
      "religious": "Religioso",
      "athlete": "Atleta",
      "unclassified": "Sin clasificar",
      "unknown": "Desconocido"
    },
    "basemapTypes": {
      "topographic": "Topográfico",
      "satellite": "Satellite",
      "light": "Light",
      "none": "Ninguno"
    },
    "mapLabels": "Etiquetas del mapa",
    "labelModes": {
      "historical": "Nombres históricos",
      "modern": "Nombres modernos",
      "both": "Ambos"
    },
    "epicTypes": {
      "wars": "Guerras",
      "empires": "Imperios",
      "religion": "Religión",
      "culture": "Cultura",
      "people": "Personas",
      "other": "Otros"
    }
  },
  "settings": {
    "title": "Configuración",
    "theme": "Tema",
    "language": "Idioma",
    "fullscreen": "Pantalla completa",
    "toggle": "Activar",
    "fontType": "Fuente",
    "markerType": "Tipo de marcador",
    "themes": {
      "light": "Claro",
      "dark": "Oscuro",
      "luther": "Luther"
    }
  },
  "timeline": {
    "expandTimeline": "Expandir línea temporal",
    "collapseTimeline": "Contraer línea temporal",
    "resetView": "Restablecer vista de la línea temporal",
    "searchEpics": "Buscar epopeyas",
    "autoplay": "Iniciar reproducción automática",
    "stopAutoplay": "Detener reproducción automática",
    "autoplayTitle": "REPRODUCCIÓN AUTOMÁTICA",
    "autoplaySubtitle": "CAMBIA EL AÑO SEGÚN EL TAMAÑO DEL PASO",
    "startYear": "Año de inicio",
    "endYear": "Año de fin",
    "stepSize": "Tamaño del paso en años",
    "delay": "Retraso en segundos",
    "repeat": "Repetir",
    "startSlideshow": "INICIAR PRESENTACIÓN"
  },
  "drawer": {
    "noContent": "Sin contenido seleccionado",
    "closePanel": "Cerrar panel",
    "provinceDataNotAvailable": "Datos de provincia no disponibles para esta selección."
  },
  "common": {
    "loading": "Cargando...",
    "close": "Cerrar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "edit": "Editar",
    "delete": "Eliminar",
    "back": "Volver",
    "ad": "d.C.",
    "bc": "a.C."
  }
}
